/* Albeux hero bottom colour.
   Reads the colour at the bottom of the hero photo (as it really looks on screen, with the dark overlay on top) and saves it as the page
   variable --acine-bottom. The bottom fade of the hero and the collection section both use that colour (see albeux-hero-loop.css),
   so the collection section is filled with the hero picture's own colour and the two join with no line.
   If the photo cannot be read for any reason, the variable is simply not set and the fallback #0D0E10 stays. */
(function () {
  var OVERLAY = [8, 6, 5];
  var ALPHA = 0.565; /* dark overlay on the hero bottom: bottom gradient 0.5 plus the edge vignette, combined */

  function measure(hero) {
    var img = hero.querySelector('.acine__img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;
    var url;
    try {
      url = new URL(src, location.href);
      url.searchParams.set('width', '300');
    } catch (e) { return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var nw = probe.naturalWidth, nh = probe.naturalHeight;
        if (!nw || !nh) return;
        var W = img.clientWidth || hero.clientWidth, H = img.clientHeight || hero.clientHeight;
        if (!W || !H) return;
        var s = Math.max(W / nw, H / nh);
        var visW = W / s, visH = H / s;
        var x0 = (nw - visW) / 2, y0 = (nh - visH) / 2;
        var sy = y0 + visH * 0.9, sh = visH * 0.08;
        var c = document.createElement('canvas');
        c.width = 16; c.height = 4;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, Math.max(0, x0), Math.max(0, sy), Math.min(nw, visW), Math.max(1, sh), 0, 0, 16, 4);
        var d = ctx.getImageData(0, 0, 16, 4).data;
        var r = 0, g = 0, b = 0, n = d.length / 4;
        for (var i = 0; i < d.length; i += 4) { r += d[i]; g += d[i + 1]; b += d[i + 2]; }
        r /= n; g /= n; b /= n;
        var out = [r, g, b].map(function (v, k) {
          return Math.max(0, Math.min(255, Math.round(v * (1 - ALPHA) + OVERLAY[k] * ALPHA)));
        });
        document.documentElement.style.setProperty('--acine-bottom', 'rgb(' + out.join(',') + ')');
      } catch (e) { /* keep the fallback colour */ }
    };
    probe.src = url.toString();
  }

  function run() {
    var hero = document.querySelector('[data-acine]');
    if (!hero) return;
    var img = hero.querySelector('.acine__img');
    if (img && !img.complete) img.addEventListener('load', function () { measure(hero); }, { once: true });
    else measure(hero);
  }

  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(run, 400); });
  document.addEventListener('shopify:section:load', run);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
